<template>
    <div class="app--engagement-loader"><AppIcon value="spinner"></AppIcon></div>
</template>
<script>
    export default {}
</script>
